/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, SAISON){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';
	const $map = location.pathname;
	let winW = $(window).width();

	// JSON取得
	const getJSONSeminar = (_yearMonth) => {
		return $.getJSON(`/ajax/seminar/${_yearMonth}.json`);
	};

	// pickup
	// <セミナーTOP>ピックアップ tabletとSPのみスライド
	function pickUpSliderSetting(){
		var width = $(window).width();
		if(width <= 1024) {
			$('.js-seminar-pickup-slider').not('.slick-initialized').slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 1,
				arrows: true,
				dots: true,
				centerMode: true,
				centerPadding: '50px',
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
			});
		} else {
			$('.js-seminar-pickup-slider.slick-initialized').slick('unslick');
		}
	}

	// <共通>カレンダースライド
	const calendarSlide = (_index) => {
		$('.seminar-calendar-list').slick({
			infinite: false,
			speed: 1500,
			autoplay: false,
			slidesToShow: 1,
			arrows: true,
			dots: false,
			initialSlide: _index,
			draggable: false,
			adaptiveHeight: true
		});
		// $('.seminar-calendar-list').slick('slickGoTo', _index);
	};

	// <共通>カレンダー
	const setCalendar = () => {
		const $output = $('.js-calendar-wrap');

		// 1ケタ月日補完
		const toDoubleDigits = (_num) => {
			_num += '';
			if(_num.length === 1) {
				_num = '0' + _num;
			}
			return _num;
		};

		// 次月取得
		const getNext = (_year, _month) => {
			if(_month + 1 > 12) {
				_month = 1;
				_year += 1;
			} else {
				_month += 1;
			}
			return([_year, _month]);
		};
		// 前月取得
		const getPrev = (_year, _month) => {
			if(_month - 1 === 0) {
				_month = 12;
				_year -= 1;
			} else {
				_month -= 1;
			}
			return([_year, _month]);
		};

		// 当月取得
		let nowDate = $('.rt_bn_latest_news .rt_current_date').text();
		const thisYear = new Date(nowDate).getFullYear();
		const thisMonth = new Date(nowDate).getMonth() + 1;
		// 来月取得
		let nextYM = getNext(thisYear, thisMonth);

		// 曜日
		const dayname = ['日','月','火','水','木','金','土'];

		const setCalendarHTML = (_year, _month) => {
			let calendarHTML = '';
			calendarHTML +=
			`<li class="js-calendar-item"><p class="seminar-calendar-yearmonth">
			<span class="js-year">${_year}</span>年 <span class="js-month">${_month}</span>月</p>
			<div class="seminar-calendar-item" data-yearmonth="${_year}${toDoubleDigits(_month)}">
			<ul class="seminar-calendar-dateWrap">`;

			// 初日の曜日を取得
			const first = new Date(_year, _month - 1, 1);
			let firstDay = first.getDay();
			let dayCount = 0;
			// 月末日取得
			const last = new Date(_year, _month, 0);
			let lastDate = last.getDate();

			// カレンダー開始日以前を埋める
			if(firstDay >= 1) {
				for(let i=0; i<firstDay; i++) {
					calendarHTML += '<li></li>';
					dayCount++;
				}
			}

			for(let i=1; i<=lastDate; i++) {
				let thisDateTime = String(_year) +'-'+ String(toDoubleDigits(_month)) +'-'+ String(toDoubleDigits(i));
				let dayofweek = dayname[new Date(thisDateTime).getDay()];
				let daynameClass = '';
				if(dayofweek === '土') {
					daynameClass = 'is-saturday';
				} else if(dayofweek === '日') {
					daynameClass = 'is-sunday';
				}
				
				calendarHTML += '<li class="seminar-calendar-date is-null '+ daynameClass +'" data-name="'+ thisDateTime +
				'"><span class="_date">'+ i +'<span class="_dayname">('+ dayofweek +')</span></li>';
				dayCount++;
			}
			while((dayCount % 7) !== 0) {
				calendarHTML += '<li></li>';
				dayCount++;
			}
			calendarHTML += '</ul></div></li>';
			return calendarHTML;
		};

		const jsonDataInput = (_yearMonth, _index) => {
			getJSONSeminar(_yearMonth).then((data) => {
				if(data.rt_bn_news_list.length) {
					let seminarData = data.rt_bn_news_list;
					
					for(let i=0; i<seminarData.length; i++) {
						let startDate = seminarData[i].rt_cf_n_start_date.datetime;
						let thisKey = seminarData[i]._key;
						let thisTagList = seminarData[i].cf_n_tags;
						let thisName;
						let thisSituation;
						let thisSituationName;
						let thisStatus = seminarData[i].rt_seminar_status.content;
						let eventStatus = seminarData[i].cf_n_event_status;
						let eventStatusClass = '';
						let thisMunic = '<br>（'+ seminarData[i].cf_n_event_municipality + '）';
						let thisTitle = seminarData[i].cf_n_title;
						let situationTag = '';

						for(let j=0; j < thisTagList.length; j++) {
							if(thisTagList[j].cf_nt_group_code === 'place') {
								thisName = thisTagList[j].cf_nt_name_d;
							} else if(thisTagList[j].cf_nt_group_code === 'situation') {
								thisSituation = thisTagList[j]._key;
								thisSituationName = thisTagList[j].cf_nt_name_d;
							}
						}
						situationTag = '<span class="_situation '+thisSituation+'">'+
						thisSituationName +'</span>';

						// オンラインセミナーの場合
						if(thisName === 'オンライン') {
							thisMunic = '';
						}

						// 生配信（オンライン）録画配信（オンライン）の場合
						if(thisSituation === 'live' || thisSituation === 'recorded') {
							thisMunic = '';
							thisName = thisSituationName;
						}

						// 中止の場合
						if(eventStatus === 4) {
							eventStatusClass = 'cancel';
						}

						let labelHTML = '<div class="_title">'+
						situationTag +
						'<a href="/seminar/detail/'+ thisKey +'.html">'+ thisTitle + '</a>';
						$('.seminar-calendar-date[data-name="'+ startDate +'"]').append(labelHTML);
						$('.seminar-calendar-date[data-name="'+ startDate +'"]').removeClass('is-null').addClass(thisStatus);
					}
				} else {
					let msgHtml = '<div class="mod-auto mt40 mb100" data-view="tablet sp"><p class="ta_center">現在予定しているセミナーはありません。</p></div>';
					$('.seminar-calendar-item[data-yearmonth="'+_yearMonth+'"]').after(msgHtml);
				}
			}).done(function(){
				// スライダーセット
				calendarSlide(_index);
				
				// 当月中の開催予定のセミナーが全て終わっている場合				
				let seminarItem = $('.seminar-calendar-date').not('.is-null');
				let pastItem = $('.seminar-calendar-date.past');
				if(_index === 0 && seminarItem.length === pastItem.length) {
					createNextCalender();
				}
			});
		};

		// 当月生成
		$output.append(setCalendarHTML(thisYear, thisMonth));
		// 当月のCMS上のデータをセット
		jsonDataInput(String(thisYear) + String(toDoubleDigits(thisMonth)), 0);
		// PCの場合は来月をデフォルトでセット
		if(winW >= 1024) {
			//$output.append(setCalendarHTML(nextYM[0], nextYM[1]));
			// jsonDataInput(String(nextYM[0]) + String(toDoubleDigits(nextYM[1])), 0);
			// <PC>スライダーセット
			// calendarSlide(0);
		}

		// 次の月
		const createNextCalender = () => {
			$('.js-next').css('opacity', '0').css('pointer-events', 'none');
			let thisIndex;
			// if(winW >= 1024) {
			// 	thisIndex = Number($('.js-calendar-wrap .slick-active:last-child').attr('data-slick-index') - 1);
			// } else {
			// 	thisIndex = Number($('.js-calendar-wrap .slick-active').attr('data-slick-index'));
			// }
			thisIndex = Number($('.js-calendar-wrap .slick-active').attr('data-slick-index'));

			let lastYear = $('.js-calendar-wrap .slick-active:last-child').find('.js-year').text();
			let lastMonth = $('.js-calendar-wrap .slick-active:last-child').find('.js-month').text();
			let lastNextYM = getNext(Number(lastYear), Number(lastMonth));

			if($('.js-calendar-wrap li:last-child').hasClass('slick-active')) {
				$('.seminar-calendar-list.slick-initialized').slick('unslick');
				// カレンダー生成
				$output.append(setCalendarHTML(lastNextYM[0], lastNextYM[1]));
				// CMS上のデータをセット
				jsonDataInput(String(lastNextYM[0]) + String(toDoubleDigits(lastNextYM[1])), thisIndex+1);
				// <PC>スライダーセット
				// if(winW >= 1024) {
				// 	calendarSlide(thisIndex);
				// }
			}
			$('.js-calendar-wrap').find('.slick-next').click();

			setTimeout(function(){
				$('.js-next').css('opacity', '1').css('pointer-events', 'auto');
			}, 1500);
		}

		// 前の月生成
		$('.js-prev').on('click', () => {
			$('.js-prev').css('opacity', '0').css('pointer-events', 'none');
			let thisIndex = Number($('.js-calendar-wrap .slick-active').attr('data-slick-index'));

			let firstYear = $('.js-calendar-wrap .slick-active:first-child').find('.js-year').text();
			let firstMonth = $('.js-calendar-wrap .slick-active:first-child').find('.js-month').text();
			let firstNextYM = getPrev(Number(firstYear), Number(firstMonth));
			if($('.js-calendar-wrap li:first-child').hasClass('slick-active')) {
				$('.seminar-calendar-list.slick-initialized').slick('unslick');
				// カレンダー生成
				$output.prepend(setCalendarHTML(firstNextYM[0], firstNextYM[1]));
				// CMS上のデータをセット
				jsonDataInput(String(firstNextYM[0]) + String(toDoubleDigits(firstNextYM[1])), 0);
				// <PC>スライダーセット
				// if(winW >= 1024) {
				// 	calendarSlide(1);
				// }
			}
			$('.js-calendar-wrap').find('.slick-prev').click();

			setTimeout(function(){
				$('.js-prev').css('opacity', '1').css('pointer-events', 'auto');
			}, 1500);
		});


		// 次の月生成
		$('.js-next').on('click', () => {
			createNextCalender();
		});
	};

	// <セミナーTOP>新着動画スライダー
	const movieSlider = () => {
		$('.js-movie-slider').slick({
			infinite: true,
			speed: 1000,
			// autoplaySpeed: 4000,
			autoplay: false,
			slidesToShow: 3,
			arrows: true,
			dots: true,
			centerMode: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}

	// <過去のセミナー開催実績>年号セレクトボックス
	const yearSelect = () => {
		// 年号セレクトボックス
		if($('.js-seminar-yearList').length) {
			const $select = $('.js-seminar-yearList');
			let latestY = Number($('.rt_latest_year').text());
			let earliestY = Number($('.rt_earliest_year').text());
			let thisY = $map.split('/')[3];
			let thisCat = $map.split('/')[4];

			for(let i = earliestY; i < latestY+1; i++) {
				if(i === Number(thisY)) {
					$select.append(`<option value="${i}" selected="selected">${i}年</option>`);
				} else {
					$select.append(`<option value="${i}">${i}年</option>`);
				}
			}
			$select.on('change', (e) => {
				let selectedY = $(e.currentTarget).val();
				if(thisCat === '' || thisCat === 'index.html') {
					location.href = '/seminar/report/'+ selectedY +'/';
				} else {
					location.href = '/seminar/report/'+ selectedY +'/'+ thisCat +'/';
				}
			});
		}
	};

	// <過去のセミナー開催実績>テンプレートを非表示
	const reportTemplate = () => {
		if($map !== '/seminar/report/' && $map !== '/seminar/report/index.html') {
			$('.js-report-content').addClass(v);
		}
	};

	// <セミナー詳細> 空の要素を非表示
	const seminarDetailBlankData = () => {
		// 会場が空欄の場合（オンライン）非表示
		let venue = $('.js-venue .rt_cf_n_event_venue').text();
		let address = $('.js-venue .rt_cf_n_event_address').text();
		if(venue === '' && address === '') {
			$('.js-venue').remove();
		}
		// 会場が空欄の場合（オンライン）非表示（開催概要（テーブル）部分）
		let tblVenue = $('.js-tbl-venue .rt_cf_n_event_venue');
		let tblAddress = $('.js-tbl-venue .rt_cf_n_event_address');
		let tblAccess = $('.js-tbl-venue .rt_cf_n_event_access');
		if(tblVenue.length === 0 && tblAddress.length === 0 && tblAccess.length === 0) {
			$('.js-tbl-venue').remove();
		}
		// サムネイルが登録されていない場合、枠事表示
		let thumb = $('.js-thumbnail .rt_cf_n_thum_img');
		if(thumb.length === 0) {
			$('.js-thumbnail').remove();
		}
	};
	// <セミナー詳細> 開催レポートが空欄の場合非表示
	const seminarDetailReport = () => {
		let reportFacebook = $('.rt_cf_n_facebook_code_is');
		let reportVideo = $('.rt_cf_n_video_id_1_is');
		if(reportFacebook.length === 0 && reportVideo.length === 0) {
			$('.js-reportBlock').remove();
		}
	};


	// <共通>カレンダー
	if($('.js-calendar-wrap').length) {
		setCalendar();
	}

	// <セミナーTOP>
	if($('.js-seminar-pickup-slider').length) {
		pickUpSliderSetting();

		$(window).resize(function(){
			pickUpSliderSetting();
		});
	}
	movieSlider();

	// <セミナー詳細>
	if($('.seminar-detail').length) {
		seminarDetailBlankData();
		seminarDetailReport();
	}

	// <過去のセミナー開催実績>
	if($('.js-report-content').length) {
		reportTemplate();
	}

	yearSelect();


})(window.jQuery, window.SAISON);
